import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ThemeQuery from './__generated__/ThemeQuery.graphql.ts';
export function preloadPageLayout(): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query({
		query: ThemeQuery,
	});
}
